import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import toast from "@/utils/toast.js"
import axios from 'axios'
import rem from "amfe-flexible"

import '@/utils/check.js'
//引入重置样式+公共样式
import "@/assets/css/reset.css"
import "@/assets/css/com.css"
//引入iconfont样式
import "@/iconfont/iconfont.css"
import "@/iconfont2/iconfont.css"
//引入瀑布流
import waterfall from 'vue-waterfall2'
//引入vant
import 'vant/lib/index.css';
import VueI18n from 'vue-i18n'
import china from './language/china'
import korean from './language/korean'
import japan from './language/japan'

// .use(VanPopup).use(VanCell)VanPopup, VanCell,
import { DropdownMenu, DropdownItem, Lazyload, Loading, CellGroup, NoticeBar, Cell, Tab, Tabs, Sticky, RadioGroup, Radio, Skeleton, Empty, CountDown, Picker, Area, Uploader, Form, Search, Button, Swipe, SwipeItem, Image as VanImage, Popup, Dialog, ImagePreview, Notify, ActionSheet, Field, Toast, List, Divider, Tabbar, TabbarItem, GoodsAction, GoodsActionIcon, GoodsActionButton, Icon, Overlay } from 'vant'
Vue.use(DropdownMenu).use(DropdownItem).use(Lazyload, { lazyComponent: true, }).use(CellGroup).use(Cell).use(Tab).use(Tabs).use(NoticeBar).use(Loading).use(Sticky).use(RadioGroup).use(Radio).use(Button).use(Skeleton).use(Empty).use(CountDown).use(Picker).use(Area).use(Uploader).use(Form).use(Search).use(Swipe).use(SwipeItem).use(VanImage).use(Popup).use(ImagePreview).use(Notify).use(ActionSheet).use(Field).use(Toast).use(List).use(Divider).use(Dialog).use(Tabbar).use(TabbarItem).use(GoodsAction).use(GoodsActionIcon).use(GoodsActionButton).use(Icon).use(Overlay)
Vue.use(waterfall).use(rem).use(toast)

Vue.use(VueI18n)

Vue.prototype.axios = axios;
Vue.config.productionTip = false
Vue.config.ignoredElements = [...Vue.config.ignoredElements, 'wx-open-launch-weapp']
const i18n = new VueI18n({
  locale: 'china',  	//默认zh 语言
  messages: {
    korean,
    china,
    japan
  }
})
// var bus = new Vue()
// Vue.prototype.$bus = bus
// pc端固定375px
if (sessionStorage.getItem('OSType') == 'PC') {
  if (sessionStorage.getItem('isWeixin') == 'false') {
    if (document.documentElement.clientWidth < 375) {
      document.body.style.width = `320px`
      document.body.style.margin = `0 auto`
      document.getElementsByTagName('html')[0].style.fontSize = `32.5px`
    } else {
      document.body.style.width = `375px`
      document.body.style.margin = `0 auto`
      document.getElementsByTagName('html')[0].style.fontSize = `37.5px`
      window.onresize = function () {
        document.getElementsByTagName('html')[0].style.fontSize = `37.5px`
      };
    }
  } else {
    document.body.style.width = `375px`
    document.body.style.margin = `0 auto`
    document.getElementsByTagName('html')[0].style.fontSize = `37.5px`
    window.onresize = function () {
      document.getElementsByTagName('html')[0].style.fontSize = `37.5px`
    };
  }
}
Toast.setDefaultOptions({ duration: 2000 });
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')

// 全局总线
